import React from "react";
import { Card, CardContent, Typography, Box, Stack } from "@mui/material";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import PaidIcon from "@mui/icons-material/Paid";
import HistoryIcon from "@mui/icons-material/History";
import { SvgIconComponent } from "@mui/icons-material";
import { FeeStatementDto } from "../../shared/dtos/studentFeeLedger/FeeStatementDto";

interface BalanceCardItemProps {
  title: string;
  amount: number;
  color: string;
  icon: SvgIconComponent;
}

const BalanceCardItem: React.FC<BalanceCardItemProps> = ({
  title,
  amount,
  color,
  icon: Icon,
}) => (
  <Card sx={{ height: "100%", borderLeft: `4px solid ${color}`, boxShadow: 2 }}>
    <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
      <Stack
        direction="row"
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
              fontWeight: 700,
              textTransform: "uppercase",
            }}
          >
            {title}
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 700, mt: 0.5 }}>
            KES {amount.toLocaleString()}
          </Typography>
        </Box>
        <Box sx={{ color, opacity: 0.85, display: "flex" }}>
          <Icon sx={{ fontSize: 32 }} />
        </Box>
      </Stack>
    </CardContent>
  </Card>
);

interface BalanceCardsProps {
  statement?: FeeStatementDto | null;
}

const BalanceCards: React.FC<BalanceCardsProps> = ({ statement }) => {
  const {
    totalInvoiced = 0,
    totalPaid = 0,
    balanceCarriedForward = 0,
    totalBalanceDue = 0,
  } = statement || {};

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          sm: "repeat(2, 1fr)",
          md: "repeat(4, 1fr)",
        },
        gap: 2,
        mt: 2,
      }}
    >
      <BalanceCardItem
        title="Arrears (B/F)"
        amount={balanceCarriedForward ?? 0}
        color="#f44336"
        icon={HistoryIcon}
      />
      <BalanceCardItem
        title="Billed This Term"
        amount={totalInvoiced ?? 0}
        color="#2196f3"
        icon={ReceiptLongIcon}
      />
      <BalanceCardItem
        title="Paid This Term"
        amount={totalPaid ?? 0}
        color="#4caf50"
        icon={PaidIcon}
      />
      <BalanceCardItem
        title="Total Balance Due"
        amount={totalBalanceDue ?? 0}
        color={(totalBalanceDue ?? 0) > 0 ? "#ff9800" : "#4caf50"}
        icon={AccountBalanceWalletIcon}
      />
    </Box>
  );
};

export default BalanceCards;
